/**
 * api.js
 * Unified Constant Pools, Utility Logic, and Dynamic Request Wrappers
 */

/* ══════════════════════════════════════════════════
   CONSTANT POOLS & REGISTRIES
   ══════════════════════════════════════════════════ */

export const MODS = [
  { id: 'aspects', l: 'ASPECTS', g: 'stroke' },
  { id: 'aspects_out', l: 'ASPECTS (outside US)', g: 'stroke' },
  { id: 'cta', l: 'CTA', g: 'stroke' },
  { id: 'hyperdensity', l: 'Hyperdensity', g: 'stroke' },
  { id: 'hypodensity', l: 'Hypodensity', g: 'stroke' },
  { id: 'ich', l: 'ICH', g: 'stroke' },
  { id: 'lumina3d', l: 'Lumina 3D', g: 'stroke' },
  { id: 'lvo', l: 'LVO', g: 'stroke' },
  { id: 'vo_plus', l: 'Vessel Occlusion+', g: 'stroke' },
  { id: 'mismatch_ctp', l: 'Mismatch (CTP)', g: 'stroke' },
  { id: 'mismatch_mri', l: 'Mismatch (MRI)', g: 'stroke' },
  { id: 'ncct_stroke', l: 'NCCT Stroke', g: 'stroke' },
  { id: 'sdh', l: 'SDH', g: 'stroke' },
  { id: 'deltafuse', l: 'DeltaFuse', g: 'stroke' },
  { id: 'midline_shift', l: 'Midline Shift', g: 'stroke' },
  { id: 'obstr_hydro', l: 'Obstr. Hydrocephalus', g: 'stroke' },
  { id: 'aneurysm', l: 'Aneurysm Triage', g: 'neuro' },
  { id: 'surgical', l: 'Surgical Preview', g: 'neuro' },
  { id: 'pe_triage', l: 'PE Triage', g: 'pulm' },
  { id: 'rv_lv', l: 'RV/LV', g: 'pulm' },
  { id: 'ipe', l: 'iPE', g: 'pulm' },
  { id: 'aortic_meas', l: 'Aortic Measurement', g: 'vasc' },
  { id: 'aortic_compare', l: 'Aortic w/ Compare', g: 'vasc' },
  { id: 'vcf', l: 'Vertebral Compression Fx', g: 'radio' },
  { id: 'c_spine', l: 'Cervical Spine Fx', g: 'radio' },
  { id: 'source_view', l: 'Source Viewing', g: 'dicom' },
  { id: 'consult', l: 'Consult', g: 'dicom' },
  { id: 'priors', l: 'Priors Support', g: 'dicom' },
  { id: 'prog_load', l: 'Progressive Loading', g: 'dicom' },
  { id: 'dicom_sr', l: 'DICOM SR Viewing', g: 'dicom' },
  { id: 'ai_edu', l: 'AI Education Viewing', g: 'dicom' },
  { id: 'pulsara', l: 'Pulsara Integration', g: 'dicom' },
  { id: 'hyp_meta', l: 'Hyperdensity Metadata', g: 'dicom' },
  { id: 'mobile_app', l: 'Mobile App', g: 'workflow' },
  { id: 'web_app', l: 'Web App', g: 'workflow' },
  { id: 'inapp_comms', l: 'In-App Comms', g: 'workflow' },
  { id: 'prescan_comms', l: 'Pre-Scan Comms', g: 'workflow' },
  { id: 'go_button', l: 'Go Button', g: 'workflow' },
  { id: 'inapp_calling', l: 'In-App Calling', g: 'workflow' },
  { id: 'adv_notif', l: 'Adv. Notifications', g: 'workflow' },
  { id: 'email_notif', l: 'Email Notifications', g: 'workflow' },
  { id: 'mfa', l: 'MFA', g: 'workflow' },
  { id: 'mismatch_ifu', l: 'Mismatch IFU', g: 'workflow' },
  { id: 'nav_pro', l: 'Navigator Pro', g: 'workflow' },
  { id: 'insights_std', l: 'Insights Standard', g: 'workflow' },
  { id: 'phi_util', l: 'PHI Util. Report', g: 'workflow' },
  { id: 'etap_ins', l: 'ETAP in Insights', g: 'workflow' },
  { id: 'cluster_tz', l: 'Cluster Time Zone', g: 'workflow' }
];

export const GO = ['stroke', 'neuro', 'pulm', 'vasc', 'radio', 'dicom', 'workflow'];

export const GL = {
  stroke: 'Stroke',
  neuro: 'Neuro',
  pulm: 'Pulmonary',
  vasc: 'Vascular',
  radio: 'Radiology',
  dicom: 'DICOM/Apps',
  workflow: 'Workflow'
};

export const GB = {
  stroke: '#DBEAFE',
  neuro: '#D1FAE5',
  pulm: '#FEF3C7',
  vasc: '#FCE7F3',
  radio: '#F3E8FF',
  dicom: '#F1F5F9',
  workflow: '#EDE9FE'
};

export const GF = {
  stroke: '#1E3A8A',
  neuro: '#064E3B',
  pulm: '#78350F',
  vasc: '#831843',
  radio: '#4C1D95',
  dicom: '#334155',
  workflow: '#3B0764'
};

export const TD = {
  Hub: ['cta', 'hyperdensity', 'hypodensity', 'ich', 'lvo', 'mismatch_ctp', 'mismatch_mri', 'ncct_stroke', 'aspects', 'source_view', 'consult', 'prog_load', 'mobile_app', 'web_app', 'inapp_comms', 'prescan_comms', 'go_button', 'inapp_calling', 'adv_notif', 'email_notif', 'mfa', 'mismatch_ifu', 'insights_std'],
  Spoke: ['cta', 'ich', 'lvo', 'ncct_stroke', 'aspects', 'source_view', 'mobile_app', 'web_app', 'inapp_comms', 'prescan_comms', 'go_button', 'inapp_calling', 'adv_notif', 'email_notif', 'mfa', 'mismatch_ifu', 'insights_std'],
  'CAH/FSED': ['cta', 'lvo', 'ncct_stroke', 'ich', 'aspects', 'mobile_app', 'web_app', 'inapp_comms', 'adv_notif', 'email_notif', 'mfa', 'insights_std'],
  MSTU: ['cta', 'lvo', 'ncct_stroke', 'ich', 'aspects', 'mobile_app', 'web_app', 'adv_notif', 'email_notif', 'mfa'],
  Clinic: ['cta', 'ncct_stroke', 'ich', 'mobile_app', 'web_app', 'adv_notif', 'email_notif', 'mfa']
};

export const TBC = { Hub: '#DBEAFE', Spoke: '#D1FAE5', 'CAH/FSED': '#FEF3C7', MSTU: '#FFEDD5', Clinic: '#F3F4F6' };
export const TTC = { Hub: '#1E3A8A', Spoke: '#064E3B', 'CAH/FSED': '#78350F', MSTU: '#7C2D12', Clinic: '#374151' };

export const CT_LABELS = {
  new_sale: 'New sale',
  renewal: 'Renewal',
  renewal_addon: 'Renewal + add-on',
  addon_only: 'Module add-on',
  scanner_addon: 'Scanner add-on',
  replacement: 'Replacement quote',
  evaluation: 'Evaluation / trial',
  research: 'Research',
  termination: 'Partial termination'
};

export const DEAL_FIELDS = [
  'quoteNum', 'oppName', 'ae', 'effDate', 'endDate',
  'tcv', 'parent', 'region', 'sfAcctId', 'ffNotes',
  'cnotes', 'repQuote', 'trialStart', 'trialEnd'
];

/* ══════════════════════════════════════════════════
   CLIENT UTILITIES
   ══════════════════════════════════════════════════ */

export const uid = () => Math.random().toString(36).slice(2, 8);

export const nowStr = () => new Date().toLocaleString('en-US', { 
  month: 'short', 
  day: 'numeric', 
  year: 'numeric', 
  hour: 'numeric', 
  minute: '2-digit', 
  hour12: true 
});

export const todayStr = () => new Date().toISOString().slice(0, 10);

export function recordAuditLog(payload) {
  const activeUser = localStorage.getItem('auth_user') || 'unknown';
  const activeUserRole = localStorage.getItem('auth_userrole') || 'unknown role';
  const backendStructuredPayload = {
    user: activeUser,
    role: activeUserRole,
    category: payload.category || '',
    action: payload.action || 'Unknown Action',
    target: payload.target || null,
    quoteNum: payload.quoteNum || '',
    intakeId: payload.intakeId || '',
    siteId: payload.siteId || '',
    route: payload.route || '',
    detail: payload.detail || '',
    source: 'client'
  };

  // 3. Dispatch the flat layout to your backend log collection route
  return requestJson('/api/audit/events', {
    method: 'PUT',
    body: JSON.stringify(backendStructuredPayload)
  });
};
  

/* ══════════════════════════════════════════════════
   NETWORK BASE CORE ENGINE
   ══════════════════════════════════════════════════ */

const BASE_URL = process.env.REACT_APP_RAPID_IMPLEMENTATION_BASE_URL || 'http://localhost:3002';
//const BASE_URL = "";

async function requestJson(endpoint, options = {}, base_url="") {
  const url = `${BASE_URL}${endpoint.startsWith('/') ? endpoint : '/' + endpoint}`;
  const auditUser = localStorage.getItem('auth_user') || 'Unknown User';
  const auditRole = localStorage.getItem('auth_userrole') || 'Guest';
  const token = localStorage.getItem('auth_token'); 
  const updatedOptions = {
    ...options,
    headers: {
      'Content-Type': 'application/json', // Preserves base JSON requirements
      'x-audit-user': auditUser,
      'x-audit-user-role': auditRole,
      'Authorization': token ? `Bearer ${token}` : '' ,
      ...(options.headers || {})         // Overwrites or appends unique individual request headers safely
    }
  };

  const response = await fetch(url, updatedOptions);
  const data = await response.json().catch(() => ({}));
  
  if (!response.ok) {
    const error = new Error(data.error || `Request failed (${response.status})`);
    error.status = response.status;
    error.data = data;
    if (!options.silent) alert(`Error Ocurred:\n${JSON.stringify(error.data.error, null, 2)}`);
    throw error;
  }
  
  return data;
}

// Authenticated file download. Plain navigations (window.open / anchor href /
// window.location.href) can't send the Authorization header, so API Gateway
// rejects them with 401 before the lambda runs — every binary download must go
// through here instead: fetch with auth headers → blob → temp <a download>.
export async function downloadFile(url, fallbackFilename) {
  const auditUser = localStorage.getItem('auth_user') || 'Unknown User';
  const auditRole = localStorage.getItem('auth_userrole') || 'Guest';
  const token = localStorage.getItem('auth_token');
  try {
    const response = await fetch(url, {
      headers: {
        'x-audit-user': auditUser,
        'x-audit-user-role': auditRole,
        'Authorization': token ? `Bearer ${token}` : ''
      }
    });

    if (!response.ok) {
      let data = {};
      try { data = await response.json(); } catch { /* non-JSON error body */ }
      alert(`Error Ocurred:\n${JSON.stringify(data.error || `Download failed (${response.status})`, null, 2)}`);
      return false;
    }

    // Server filename wins when readable (lambda exposes Content-Disposition cross-origin).
    let filename = fallbackFilename || 'download';
    const disposition = response.headers.get('Content-Disposition') || '';
    const dispositionMatch = disposition.match(/filename="?([^";]+)"?/i);
    if (dispositionMatch && dispositionMatch[1]) filename = dispositionMatch[1];

    const blob = await response.blob();
    const objectUrl = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = objectUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(objectUrl);
    return true;
  } catch (e) {
    alert(`Error Ocurred:\n${JSON.stringify(e.message, null, 2)}`);
    return false;
  }
}

/* ══════════════════════════════════════════════════
   REFACTORED MODULAR EXPORTS (API METHOD SPACE)
   ══════════════════════════════════════════════════ */

// ── 1. CORE INTAKE ACTIONS ──
export const createIntake = () => requestJson('/api/intakes', { method: 'POST' });

export const getIntake = (id) => requestJson(`/api/intakes/${encodeURIComponent(id)}`);

export const updateIntake = (id, state) => requestJson(`/api/intakes/${encodeURIComponent(id)}`, {
  method: 'PUT',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify(state)
});

export const lookupAnyIntake = (quoteNum, excludeId) => {
  const params = new URLSearchParams({ quoteNum });
  if (excludeId) params.set('excludeId', excludeId);
  return requestJson(`/api/intakes/lookup-any?${params.toString()}`, { silent: true });
};

export const overrideDuplicateQuote = (id, quoteNum) => requestJson(
  `/api/intakes/${encodeURIComponent(id)}/override-duplicate`,
  { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ quoteNum }) });

export const submitInaccuracyClaim = (id, comment, token, name) => requestJson(`/api/intakes/${encodeURIComponent(id)}/inaccuracy-claim`, {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify({ comment, token: token || '', name: name || '' })
});

export const generateSignoffLink = (id, email, name) => requestJson(`/api/intakes/${id}/send`, {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify({ aeEmail: email, aeName: name })
});

export const submitSignoff = (id, payload) => requestJson(`/api/intakes/${id}/signoff`, {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify(payload)
});

export const validateSignoffToken = (token) => requestJson(`/api/signoff/${encodeURIComponent(token)}`);

// Absolute URLs for the landscape PDF downloads (must point at the intake API base,
// not the SPA origin). signoff-pdf carries the fillable AE sign-off fields and is
// ungated; review-pdf is the post-sign-off copy and requires AE approval.
export const getSignoffPdfUrl = (id) => `${BASE_URL}/api/intakes/${encodeURIComponent(id)}/signoff-pdf`;
export const getReviewPdfUrl = (id) => `${BASE_URL}/api/intakes/${encodeURIComponent(id)}/review-pdf`;

export const parseContractServer = (content, mimeType, filename, intakeId) => requestJson('/api/parse-contract', {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify({ content, mimeType, filename, intakeId })
});

// ── 2. AUDIT PORTAL METHODS ──
export const fetchAuditEvents = (filters = {}) => {
  const queryParams = new URLSearchParams();
  Object.entries(filters).forEach(([key, val]) => {
    if (val !== undefined && val !== null && val !== '') {
      queryParams.set(key, val);
    }
  });
  return requestJson(`/api/audit/events?${queryParams.toString()}`, { method: 'GET' });
};

export const triggerAuditExportDownload = (filters = {}) => {
  const queryParams = new URLSearchParams();
  Object.entries(filters).forEach(([key, val]) => {
    if (val !== undefined && val !== null && val !== '') {
      queryParams.set(key, val);
    }
  });
  return downloadFile(`${BASE_URL}/api/audit/export?${queryParams.toString()}`, `audit-log_${todayStr()}.txt`);
};

// ── 3. INSTALL CHECKLIST METHODS ──
export const fetchFinalizedIntakes = () => requestJson('/api/intakes/finalized', { method: 'GET' });

export const lookupIntakeMatches = (quoteNum) => 
  requestJson(`/api/intakes/lookup?quoteNum=${encodeURIComponent(quoteNum)}`, { method: 'GET' });

export const getChecklistRecord = (quoteNum, siteId, intakeId) => {
  const params = new URLSearchParams({ quoteNum, siteId, intakeId });
  return requestJson(`/api/install-checklists?${params.toString()}`, { method: 'GET' });
};

export const updateChecklistRecord = (quoteNum, siteId, intakeId, payload) => {
  const params = new URLSearchParams({ quoteNum, siteId, intakeId });
  return requestJson(`/api/install-checklists?${params.toString()}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  });
};

// export const fetchSiteDiagnosticsInfo = (quoteNum, siteId, intakeId, phase, orderedModuleIds) => {
//   const params = new URLSearchParams({ quoteNum, siteId, intakeId, phase });
//   orderedModuleIds.forEach(id => params.append('orderedModuleIds', id));
//   return requestJson(`/api/install-checklists/site-info?${params.toString()}`, { method: 'GET' });
// };

export const getChecklistPdfBundleUrl = (quoteNum, siteId, intakeId) => {
  const params = new URLSearchParams({ quoteNum, siteId, intakeId });
  return `${BASE_URL}/api/install-checklists/pdf-bundle?${params.toString()}`;
};

// ── 4. SALESFORCE PROVISIONING HANDSHAKES ──
export const triggerSalesforceUpdate = (quoteNum, siteId, intakeId) => {
  const params = new URLSearchParams({ quoteNum, siteId, intakeId });
  return requestJson(`/api/install-checklists/salesforce-update?${params.toString()}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({})
  });
};

// ── 5. ASSIGNED REVIEWS & OPERATIONS QUEUE METHODS ──
export const fetchQueueRecords = (includeInstallComplete) => 
  requestJson(`/api/quotes?includeInstallComplete=${Boolean(includeInstallComplete)}`, { method: 'GET' });

export const fetchValidationDetails = (id) => 
  requestJson(`/api/intakes/${encodeURIComponent(id)}/install-validation`, { method: 'GET' });

export const saveValidationPayload = (id, payload) => 
  requestJson(`/api/intakes/${encodeURIComponent(id)}/install-validation`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  });

export async function logPortalAccess(portalName, portalRoute) {
  try {
    await recordAuditLog({
      category: 'navigation',
      action: `Viewed ${portalName}`,
      detail: `Opened ${portalName}.`,
      target: portalName,
      route: portalRoute ? `GET ${portalRoute}` : '',
      quoteNum: '',
      intakeId: '',
      siteId: '',
    });
  } catch (e) {
    console.warn('[Telemetry Core] Portal access tracking failed:', e.message);
  }
}

export const getSiteInfo = async (parentSite, subSite) => 
  requestJson(`/api/siteinfo`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ parentSite, subSite })
  });

export const fetchSiteDiagnosticsInfo = async (projectId, clusterId, siteCode) => {
  const RAPID_HEALTHCHECK_URL = process.env.REACT_APP_RAPID_HEALTHCHECK_BASE_URL;
  const token = localStorage.getItem('auth_token'); 

  return fetch(RAPID_HEALTHCHECK_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token ? `Bearer ${token}` : '' 
    },
    body: JSON.stringify({
      action: 'installedModuleInfo',
      projectId,
      clusterId,
      siteCode,
      tab: ""
    })
  })
  .then(response => {
    if (!response.ok) throw new Error(`API tracking call failed: ${response.status}`);
    return response.json();
  })
  .then(data => {
    return {
      ...data.responseData,
      found: true
    };
  })
  .catch(error => {
    console.error('[Telemetry Diagnostics Error] Network request aborted:', error.message);
    return { found: false, message: error.message, server: {}, modules: {} };
  });
};
  
export const submitInaccuracyResolution = (id, decision, reason) => 
  requestJson(`/api/intakes/${encodeURIComponent(id)}/inaccuracy-resolution`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ decision, reason })
  });

/* ══════════════════════════════════════════════════
   BACKWARD COMPLIANCE INTERFACE BRIDGE (LEGACY API OBJECT)
   ══════════════════════════════════════════════════ */
export const api = {
  createIntake, getIntake, updateIntake, lookupAnyIntake, overrideDuplicateQuote,
  submitInaccuracyClaim, generateSignoffLink, submitSignoff,
  validateSignoffToken, parseContractServer,
  getSignoffPdfUrl, getReviewPdfUrl,
  fetchAuditEvents, triggerAuditExportDownload, fetchFinalizedIntakes,
  lookupIntakeMatches, getChecklistRecord, updateChecklistRecord,
  fetchSiteDiagnosticsInfo, getChecklistPdfBundleUrl, triggerSalesforceUpdate,
  fetchQueueRecords, fetchValidationDetails, saveValidationPayload,
  submitInaccuracyResolution, logPortalAccess, getSiteInfo, // <--- ADD THIS LINE HERE TO ATTACH IT TO THE API OBJECT
  downloadFile
};